module.exports = __webpack_public_path__ + "static/media/lascano-video.00f4cec8.webm";